import { render } from "./signin-page.vue?vue&type=template&id=0b4fbfa7"
import script from "./signin-page.vue?vue&type=script&lang=js"
export * from "./signin-page.vue?vue&type=script&lang=js"

import "./signin-page.vue?vue&type=style&index=0&id=0b4fbfa7&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__